import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  badge: {
    fontFamily: 'BentonSansBold',
    fontSize: '14px !important',
    height: '22px !important',
    paddingTop: '6px !important',
    margin: '20px 0px 0px 20px !important',
    textAlign: 'center',
    maxWidth: '85px'
  },
  card: {
    backgroundColor: 'var(--primary__page__background) !important',
    borderBottomLeftRadius: '0 !important'
  },
  cardBody: {
    backgroundColor: 'var(--primary__page__background) !important'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between !important'
  },
  carousel: {
    '&:after': {
      content: "' '",
      minWidth: '20px'
    },
    padding: '15px'
  },
  scenariosCarousel: ({ hasMultipleActions }) => ({
    '&:after': {
      content: "' '",
      display: !hasMultipleActions && 'none',
      minWidth: '20px'
    },
    padding: '5px 35px 40px 15px'
  }),
  mediaContainer: {
    '@media (max-width: 667px)': {
      cardBody: {
        padding: '6px 16px !important'
      }
    }
  },
  subheader: {
    display: 'flex',
    flexDirection: 'row !important',
    justifyContent: 'flex-start !important'
  },
  text: {
    marginRight: '5px'
  },
  title: {
    fontWeight: '600 !important'
  }
})

export default useStyles
